import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import UserLink from '../../../User/Link';
import AuthorWatchButton from '../../../Button/AuthorWatchButton';
import s from './Author.scss';
const Author = ({ author , isOwner , withByline =true , className  })=>{
    const { t  } = useTranslation();
    if (!author) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, withByline && /*#__PURE__*/ React.createElement("div", {
        className: s['by']
    }, t('deviation.details.by'), " "), /*#__PURE__*/ React.createElement(UserLink, {
        className: s['username'],
        usernameClassName: s['username-inner'],
        withTooltip: true,
        user: author
    }), !isOwner && /*#__PURE__*/ React.createElement(AuthorWatchButton, {
        author: author
    }));
};
Author.displayName = 'Author';
export default Author;
